// import interfaceStudyPackage from './interface-studypackage'
// import interfaceAccount from './interface-account'
import interfaceActive from './interface-active'

let mergeInterface = Object.assign({}, interfaceActive)

export default mergeInterface


// WEBPACK FOOTER //
// ./src/api/interface.js